interface QualityMetric {
  label: string;
  value: number;
  icon: string;
}

interface Props {
  metrics: QualityMetric[];
  indiceGeral: number;
}

export default function ProjectQualityPanel({ metrics, indiceGeral }: Props) {
  return (
    <div>
      <div className="flex items-center gap-4 mb-4 p-4 rounded-lg bg-primary-50 border border-primary-200">
        <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center shrink-0">
          <span className="text-lg font-bold text-primary-600 font-heading">{indiceGeral}%</span>
        </div>
        <div>
          <p className="text-sm font-semibold text-foreground-900 font-heading">Índice de Qualidade do Cadastro</p>
          <p className="text-xs text-foreground-500">Média ponderada dos 6 indicadores de qualidade</p>
        </div>
      </div>

      <div className="space-y-3">
        {metrics.map((metric, i) => (
          <div key={i}>
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-1.5">
                <i className={`${metric.icon} text-xs text-foreground-400`} aria-hidden="true"></i>
                <span className="text-xs text-foreground-700">{metric.label}</span>
              </div>
              <span className={`text-xs font-bold tabular-nums font-heading ${metric.value >= 90 ? "text-primary-600" : metric.value >= 70 ? "text-warning-600" : "text-danger-600"}`}>
                {metric.value}%
              </span>
            </div>
            <div className="h-2 rounded-full bg-background-200 overflow-hidden">
              <div
                className={`h-full rounded-full transition-all duration-500 ${
                  metric.value >= 90 ? "bg-primary-500" : metric.value >= 70 ? "bg-warning-500" : "bg-danger-500"
                }`}
                style={{ width: `${metric.value}%` }}
                role="progressbar"
                aria-valuenow={metric.value}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`${metric.label}: ${metric.value}%`}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}